import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';
import {DoublyRobustRegression} from 'shared/dtos/cockpit-kontrolle/modellvarianten-m1';

@Component({
  selector: 'app-modellvarianten-drr-table',
  templateUrl: './modellvarianten-drr-table.component.html',
  styleUrls: [
    './modellvarianten-drr-table.component.scss',
    '../../../../cockpit-shared/contents/cockpit-styles.scss'
  ],
  standalone: false
})
export class ModellvariantenDrrTableComponent
  extends CurrentLocaleComponent
  implements OnInit
{
  @Input() data: DoublyRobustRegression;

  constructor(protected readonly translate: TranslateService) {
    super(translate);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
